<template>
  <div class="alert-wrapper" v-show="show">
    <div class="alert-content">
      <div class="title_box">
        <span class="warning iconfont icon-shibai" v-if="alertType==='warning'"></span>
        <span class="success iconfont icon-success" v-if="alertType==='success'"></span>
        <span class="info iconfont icon-tishi" v-if="alertType==='info'"></span>
        提示
      </div>
      <div v-if="title" class="title">{{title}}</div>
      <div class="content">
        <div>{{ messageOne }}</div>
        <div>{{ messageTwo }}</div>
        <!-- <slot></slot> -->
      </div>
      <div class="button-group clear">
        <div class="confirm hand right" @click="confirmClick">{{ confirmText }}</div>
        <div class="cancel hand right" @click="cancelClick" v-if="cancelText">{{ cancelText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 弹出Model框
 * 
 * 
 */
// import { Component, Vue, Prop } from 'vue-property-decorator'
// @Component
// export default class Model extends Vue {
//   @Prop()
//   title: string = ''
//   message: string = ''
//   cancelText: string = ''
//   confirmText: string = ''
//   show: boolean = true
//   protected cancelClick() {
//     this.$emit('handleShow', false)
//     this.$emit('cancel')
//   }
//   protected confirmClick() {
//     this.$emit('handleShow', false)
//     this.$emit('confirm')
//   }
// }
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    messageOne: {
      type: String,
      default: ''
    },
    messageTwo: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String  
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    show: {
      type: Boolean,
      required: true
    },
    alertType: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'show',
    event: 'handleShow'
  },
  created() {

  },
  methods: {
    cancelClick() {
      this.$emit('handleShow', false)
      this.$emit('cancel')
    },
    confirmClick() {
      this.$emit('handleShow', false)
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="less" scoped>
.alert-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 99;
  .alert-content {
    background: #fff;
    border-radius: 6px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    width: 400px;
    .title {
      font-size: 14px;
      font-weight: 600;
      color: #333;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      padding: 0.2rem 0;
      text-align: center;
    }
    .title_box {
      padding: 10px 0;
      font-size: 16px;
      color: #333333;
      font-size: 16px;
      font-weight: bold;
      .warning {
        font-size: 25px;
        color: #f5222d;
        margin-right: 5px;
        font-weight: normal;
      }
      .success {
        font-size: 25px;
        color: #52c41a;
        margin-right: 5px;
        font-weight: normal;
      }
      .info {
        font-size: 25px;
        color: #f5222d;
        margin-right: 5px;
        font-weight: normal;
      }
    }
    .content {
      font-size: 14px;
      padding: 0 27px;
    }
    .button-group {
      font-size: 15px;
      margin-top: 15px;
      .cancel {
        padding: 3px 15px;
        border: 1px solid #dedede;
        color: #999;
        border-radius: 6px;
      }
      .confirm {
        padding: 3px 15px;
        border: 1px solid #dedede;
        color: #ffffff;
        background-color: #1890ff;
        border-color: #1890ff;
        border-radius: 6px;
        margin-left: 10px;
      }
    }
  }
}
</style>
